import React, { Component } from 'react';
import PropTypes from 'prop-types';
import FocusTrap from '@pattern-library/focus-trap';
import FocusService from '@pattern-library/utils/dist/FocusService';
import { ChevronDownBoldIcon } from '@pattern-library/icon';
class Dropdown extends Component {
  constructor(props) {
    super(props);
    this.handleClickOutside = event => {
      const domNode = this.containerRef.current;
      if (!domNode || !domNode.contains(event.target)) {
        this.setState({
          open: false
        });
        this.props.onClose();
      }
    };
    this.handleKeyDown = event => {
      const ESC_KEY = 27;
      if (event.which === ESC_KEY) {
        this.toggleDropdown();
      }
    };
    this.handleTrapFocusBottom = () => {
      this.toggleDropdown();
    };
    this.toggleDropdown = () => {
      const open = !this.state.open;
      this.setState({
        open: open
      });
      if (open) {
        FocusService.focusFirstElementIn(this.dropdownContentRef.current);
        this.props.onOpen();
      } else {
        FocusService.focusElement(this.buttonRef.current);
        this.props.onClose();
      }
    };
    const {
      id,
      triggerRef
    } = props;
    this.state = {
      buttonId: `${id}-dropdown-button`,
      labelId: `${id}-dropdown-label`,
      dropdownId: `${id}-dropdown-content`,
      open: false
    };
    this.buttonRef = triggerRef ? triggerRef : /*#__PURE__*/React.createRef();
    this.dropdownContentRef = /*#__PURE__*/React.createRef();
    this.containerRef = /*#__PURE__*/React.createRef();
  }
  componentDidMount() {
    document.addEventListener('click', this.handleClickOutside, true);
  }
  componentDidUpdate(prevProps) {
    if (this.props.closeWhen && this.props.closeWhen !== prevProps.closeWhen) {
      this.setState({
        open: false
      });
      FocusService.focusElement(this.buttonRef.current);
      this.props.onClose();
    }
  }
  componentWillUnmount() {
    document.removeEventListener('click', this.handleClickOutside, true);
  }
  render() {
    const {
      buttonText,
      content,
      label,
      buttonClassName,
      iconProps
    } = this.props;
    const containerClass = 'asc-dropdown-container';
    const buttonClass = buttonClassName ? buttonClassName : 'asc-dropdown-button';
    let classes = this.state.open ? `${containerClass} is-open` : containerClass;
    let buttonClasses = this.state.open ? `${buttonClass} is-open` : buttonClass;
    return /*#__PURE__*/React.createElement("div", {
      ref: this.containerRef,
      className: "asc-dropdown"
    }, label && /*#__PURE__*/React.createElement("p", {
      className: "asc-form-label",
      id: this.state.labelId,
      "aria-hidden": "true"
    }, label), /*#__PURE__*/React.createElement("button", {
      className: buttonClasses,
      id: this.state.buttonId,
      type: "button",
      "aria-labelledby": `${this.state.labelId} ${this.state.buttonId}`,
      "aria-expanded": this.state.open,
      "aria-controls": this.state.dropdownId,
      "aria-haspopup": "true",
      onClick: this.toggleDropdown,
      ref: this.buttonRef
    }, buttonText, /*#__PURE__*/React.createElement(ChevronDownBoldIcon, iconProps)), /*#__PURE__*/React.createElement("div", {
      className: classes,
      id: this.state.dropdownId,
      role: "none",
      onKeyDown: this.handleKeyDown
    }, /*#__PURE__*/React.createElement(FocusTrap, {
      onBottomFocus: this.handleTrapFocusBottom,
      onTopFocus: this.handleTrapFocusBottom
    }, /*#__PURE__*/React.createElement("div", {
      ref: this.dropdownContentRef
    }, content))));
  }
}
Dropdown.propTypes = {
  /**
   * Optional label to the dropdown group
   **/
  label: PropTypes.string,
  /**
   * Text in the dropdown trigger
   **/
  buttonText: PropTypes.node.isRequired,
  /**
   * Item or content to be displayed in the dropdown area
   **/
  content: PropTypes.any.isRequired,
  /**
   * Override of button classes
   */
  buttonClassName: PropTypes.string,
  /**
   * Pass true to close manually
   **/
  closeWhen: PropTypes.bool,
  /**
   * Unique ID required for connecting accessibility attributes in the DOM
   **/
  id: PropTypes.string.isRequired,
  /**
   * A function called when the dropdown is opened
   */
  onOpen: PropTypes.func,
  /**
   * A function called when the dropdown is closed
   */
  onClose: PropTypes.func,
  /**
   * Ref object for the trigger button
   */
  triggerRef: PropTypes.object,
  /**
   * Color for dropdown icon
   */
  iconProps: PropTypes.objectOf(PropTypes.string)
};
Dropdown.defaultProps = {
  label: '',
  closeWhen: false,
  onOpen: () => {},
  onClose: () => {},
  iconProps: {
    size: 'xxs',
    color: 'default'
  }
};
export default Dropdown;